// extracted by mini-css-extract-plugin
export default {"titleHolder":"Title_titleHolder__dgICU","lineTitle":"Title_lineTitle__Pdt+q","title":"Title_title__pjiK+"};